<script lang="ts">
    import {getCdnUrl} from "$lib/cdn";
    import ButtonGroup from "../Elements/ButtonGroup.svelte";

    export let section: Section;
    export let index: number;

    $: bullets = section.bullets ? section.bullets.split("\n") : [];
    $: imageUrl = section.image.data.attributes.formats?.large ? section.image.data.attributes.formats.large.url : section.image.data.attributes.url

</script>

<div class="relative isolate pt-12" class:bg-gray-200={index !== 0}>
    <div class="py-0 sm:py-20 lg:pb-40">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl lg:text-center">
                {#if index === 0}
                    <h1 class="text-5xl font-bold tracking-tight sm:text-6xl font-display">
                        {section.title}
                    </h1>
                {:else}
                    <h2 class="text-4xl font-bold tracking-tight sm:text-5xl font-display">
                        {section.title}
                    </h2>
                {/if}

                <p class="mt-6 text-lg leading-8"> {section.description}</p>

                {#if bullets.length > 0}
                    <ul role="list"
                        class="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base leading-7 sm:grid-cols-2 text-left">
                        {#each bullets as bullet}
                            <li class="flex gap-x-3">
                                <svg class="h-7 w-5 flex-none" viewBox="0 0 20 20" fill="currentColor"
                                     aria-hidden="true">
                                    <path fill-rule="evenodd"
                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                          clip-rule="evenodd"/>
                                </svg>
                                {bullet}
                            </li>
                        {/each}
                    </ul>
                {/if}

                {#if section.cta.length > 0}
                    <div class="mt-10 flex items-center justify-center gap-x-6">
                        <ButtonGroup buttons={section.cta}/>
                    </div>
                {/if}
            </div>
            <div class="mt-16 flow-root sm:mt-24">
                <div class="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4 bg-base-100">
                    <img src={getCdnUrl(imageUrl)} alt={section.image.data.attributes.alternativeText} width="2432" height="1442" class="rounded-md shadow-2xl ring-1 ring-gray-900/10">
                </div>
            </div>
        </div>
    </div>
</div>
